export default {
  header: "Understanding Your Risk",
  view: "Main"
};
